export default __webpack_public_path__ + "static/media/Aalac.e6770425.png";